export function demo() {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve({code: 200, data: {'hello': 'world'}});
        }, 300);
    });
}